// extracted by mini-css-extract-plugin
export var autoExpand = "_1t-8";
export var container = "_1t-7";
export var containerWidth = "_1t-5";
export var disabled = "_1t-2";
export var error = "_1t-3";
export var fullWidth = "_1t-6";
export var inputWrapper = "_1t-0";
export var small = "_1t-1";
export var textarea = "_1t-4";